import { createContext } from 'react';
import { IPlan } from '../../../../api/plans/interfaces/planInterface';

interface IPlanContext {
	plans?: IPlan[];
	setPlan: (value: IPlan) => void;
	plan?: IPlan;
	/**
	 * Parcelas escolhidas no formulário. O resumo usa para mostrar o total que de fato será
	 * cobrado: em 1x entra o desconto à vista do plano (ver `planCashDiscount`).
	 */
	installmentCount?: number;
	setInstallmentCount?: (value: number) => void;
}

export const PlanContext = createContext<IPlanContext>({
	setPlan: () => false
});
